import Home from './components/Home.vue';
import App from './App.vue';
import Article from './components/NewArticle.vue';
import NewProduct from './components/NewProduct.vue';

export const routes = [
    { path: '', component: Home, alias: '/' },
	{ path: '/new-article', component: Article },
	{ path: '/article', component: Article },
	{ path: '/new-product', component: NewProduct },
	{ path: '/product', component: NewProduct }
];


// WEBPACK FOOTER //
// ./src/routes.js